import { Component, ElementRef, OnInit} from '@angular/core';
import { NavBarObject} from "../../../_components/nav-bar/config";
import { Periodo} from "../../../_models/interfaces";
import { ActivatedRoute, Router} from "@angular/router";
import { Title} from "@angular/platform-browser";
import { MatTableDataSource } from "@angular/material/table";
import { NivelacionesService} from "../_services/nivelaciones.service";

const MockData = [
    {materia: {},}
];

@Component({
    selector: 'nivelaciones-reporte-curso',
    standalone: false,
    templateUrl: 'nivelaciones-reporte-curso.component.html',
    styleUrls: ['nivelaciones-reporte-curso.component.scss'],
    host: {
        "(click)": "offClick($event)"
    }
})

export class NivelacionesReporteCursoComponent implements OnInit {

    periodosNavBar;
    periodoSeleccionado: string | number = 0;
    dataSource: MatTableDataSource<any>;
    displayedColumns = ['Curso', 'Materia', 'Profesor', 'Citaciones', 'Total', 'S', 'A', 'B', 'D', 'I', 'NA'];
    mesEnCurso: number | string;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private titleService: Title,
                private nivelacionesService: NivelacionesService,
                private elRef: ElementRef) {
    }

    ngOnInit() {
        this.periodoSeleccionado = this.route.snapshot.paramMap.get('idPeriodo');

        this.route.parent.data.subscribe((data: { periodos: Periodo[] }) => {
            const periodo = data.periodos[0];
            this.periodosNavBar = [new NavBarObject(
                periodo.nombre,
                [`/nivelaciones/reportes/cursos/periodo/${periodo.id}`],
                periodo.id,
                [new NavBarObject('Acumulado', [`/nivelaciones/reportes/cursos/periodo/${periodo.id}`], periodo.id)].concat(
                    periodo.periodos.map((child, i) => {
                        // if (!this.periodoSeleccionado){ /*&& periodo.periodos.length - 1 == i) {*/
                        //     this.periodoSeleccionado = periodo.id;
                        // }
                        if (child.tipo < 2) {
                            return new NavBarObject(`Periodo ${child.nombre}`, [`/nivelaciones/reportes/cursos/periodo/${child.id}`], child.id)
                        } else {
                            return false;
                        }
                    }))
            )];
        });

        if (!this.periodoSeleccionado){ /*&& periodo.periodos.length - 1 == i) {*/
            this.periodoSeleccionado = 0;
        }

        this.nivelacionesService.getReporteCursoPeriodo(this.periodoSeleccionado).subscribe(res => {
            this.dataSource = new MatTableDataSource<any>(res);
            this.dataSource.filterPredicate = (data, filter: string) => {
                let retProf = "";
                const accumulator = (currentTerm, key) => {
                    if (key == 'profesores') {
                        data.profesores.map(prof => {
                            retProf += `<li>${prof.nombresApellidos}</li>`;
                        });
                    }
                    if (key == 'materia') {
                        retProf += `${data.materia.nombreCompleto} ${data.materia.cursoNickName}`;
                    }
                    return retProf ? retProf : currentTerm + data[key];
                };
                const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
                // Transform the filter by converting it to lowercase and removing whitespace.
                const transformedFilter = filter.trim().toLowerCase();
                return dataStr.indexOf(transformedFilter) !== -1;
            };
        });

        this.mesEnCurso = new Date().getMonth() + 1;

        this.titleService.setTitle('Nivelaciones - Reporte curso');
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }

    toggleDetalles(detalleElement){
        let els = this.elRef.nativeElement.querySelectorAll('.detalle'),
            control = detalleElement.hidden;
        els.forEach(el => {
            el.hidden = true;
        });
        if(control){
            detalleElement.hidden = !detalleElement.hidden;
        }
    }

    filtroTexto(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

    offClick(evt){
        if (!evt.target.classList.contains('circulo') && !evt.target.classList.contains('detalle') && !evt.target.classList.contains('detalle-lista') && !evt.target.classList.contains('detalle-item')) {
            let els = Array.prototype.slice.call(this.elRef.nativeElement.querySelectorAll('.detalle')),
                shownEl = els.filter(el => el.hidden == false);
            if(shownEl.length == 1){
                shownEl[0].hidden = true;
            }
        }
    }
}
